import React, { useState, useEffect, useCallback } from 'react';
import {
  CCard,
  CCardBody,
  CCardHeader,
  CFormInput,
  CButton,
  CCol,
  CRow,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
} from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import { cilSearch } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { useLoaderData } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import debounce from 'lodash.debounce';
import { useConvertToLocalTime } from 'src/components/store/useConvertToLocalTime';
import PermissionsNoPage, { Permissions } from 'src/components/Permissions';

const page = 1;
const urlApi = '/service_order_histories';

export async function LoaderServiceOrders() {
  const res = await AxiosInstance.get(`${urlApi}?page=${page}`).then((response) => response);
  return res;
}

const ServiceOrders = ({ user_data }) => {
  // if (!PermissionsNoPage(user_data, 'Applications', 'VIEW_APPLICATIONS')) {
  //   return <PermissionsNoPage />;
  // }
  const { data } = useLoaderData();

  const [rows, setRows] = useState(data['hydra:member'] || []);
  const [rowCountState, setRowCountState] = useState(data['hydra:totalItems'] || 0);
  const [nameFilter, setNameFilter] = useState('');

  useEffect(() => {
    setRows(data['hydra:member'] || []);
    setRowCountState(data['hydra:totalItems'] || 0);
  }, [data]);

  const getRowsTable = useCallback(
    (p = 1) => {
      const trimmedName = nameFilter.trim();
      const nameQuery = trimmedName ? `&name=${encodeURIComponent(trimmedName)}` : '';

      AxiosInstance.get(`${urlApi}?page=${p}${nameQuery}`).then((response) => {
        setRows(response.data['hydra:member']);
        setRowCountState(response.data['hydra:totalItems']);
      });
    },
    [nameFilter]
  );

  const debouncedSearch = useCallback(
    debounce(() => {
      getRowsTable(1);
    }, 500),
    [getRowsTable]
  );

  useEffect(() => {
    debouncedSearch();
    return debouncedSearch.cancel;
  }, [nameFilter, debouncedSearch]);

  const handlePageChange = (page) => {
    getRowsTable(page + 1);
  };

  const handleClearFilters = () => {
    setNameFilter('');
    getRowsTable(1);
  };

  const columns = [
    { field: 'id', headerName: 'ID', width: 80 },
    { field: 'name', headerName: 'Назва заявки', width: 260 },
    {
      field: 'personalAccount',
      headerName: 'Особовий рахунок',
      width: 180,
      valueGetter: (params) => params.row.personalAccount?.number || '',
    },
    {
      field: 'status',
      headerName: 'Статус',
      width: 140,
    },
    {
      field: 'type',
      headerName: 'Тип',
      width: 100,
    },
    {
      field: 'dateEntered',
      headerName: 'Дата створення',
      width: 200,
      valueGetter: (params) =>
        params.row.dateEntered ? useConvertToLocalTime(params.row.dateEntered) : '',
    },
    {
      field: 'dateModified',
      headerName: 'Дата зміни',
      width: 200,
      valueGetter: (params) =>
        params.row.dateModified ? useConvertToLocalTime(params.row.dateModified) : '',
    },
    {
      field: 'idCrm',
      headerName: 'ID CRM',
      width: 120,
    },
    {
      field: 'action',
      headerName: 'Переглянути',
      width: 120,
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => (
        <Link
          to={`/service-orders/view/${params.row.id}`}
          className="cutom-view-icon"
        >
          <CIcon icon={cilSearch} customClassName="nav-icon" height={18} />
        </Link>
      ),
    },
  ];

  return (
    <CRow>
      <CCol xs={12}>
        <CCard className="mb-4">
          <CAccordion flush>
            <CAccordionItem>
              <CAccordionHeader>
                <strong>Фільтр</strong>
              </CAccordionHeader>
              <CAccordionBody>
                <CRow className="my-3 mx-2">
                  <CCol md={8}>
                    <CFormInput
                      placeholder="Назва заявки"
                      value={nameFilter}
                      onChange={(e) => setNameFilter(e.target.value)}
                      autoComplete="off"
                    />
                  </CCol>
                  <CCol md={4}>
                    <CButton color="secondary" variant="outline" onClick={handleClearFilters}>
                      Очистити фільтри
                    </CButton>
                  </CCol>
                </CRow>
              </CAccordionBody>
            </CAccordionItem>
          </CAccordion>

          <CCardHeader>
            <strong>Заявки</strong>
          </CCardHeader>
          <CCardBody>
            <div style={{ height: 600, width: '100%' }}>
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={30}
                rowsPerPageOptions={[30]}
                pagination
                rowCount={rowCountState}
                paginationMode="server"
                onPageChange={handlePageChange}
              />
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default ServiceOrders;


